import { createSelector } from 'reselect';
import { RootState } from 'MyTypes';

const errorModalStore = (state: RootState) => state.errorModal;

export const selectErrorModalMsg = createSelector(errorModalStore, (store) => store?.msg);

export const selectErrorModalOnClose = createSelector(errorModalStore, (store) => store?.onClose);
